"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceInitialized = exports.getMissingRequiredInstanceParams = exports.getSessionFromInstance = void 0;
exports.getSessionFromInstance = (instance) => ({
    tenantId: instance.tenantId,
    sessionId: instance.sessionId,
    sessionCreated: instance.sessionCreated,
    environment: instance.environment,
    dataResidency: instance.dataResidency,
    country: instance.country,
    locationAccuracy: instance.locationAccuracy,
    latitude: instance.latitude,
    longitude: instance.longitude,
    spaceId: instance.spaceId,
    appId: instance.appId,
    appVersion: instance.appVersion,
    installationId: instance.installationId,
    installationVersion: instance.installationVersion,
    deviceId: instance.deviceId,
    clientId: instance.clientId,
});
exports.getMissingRequiredInstanceParams = (initParams) => {
    const requiredFields = [
        'tenantId',
        'environment',
        'dataResidency',
        'country',
        'appId',
        'installationId',
    ];
    const missingParams = requiredFields.filter((field) => !initParams[field]);
    return missingParams;
};
exports.isInstanceInitialized = (instance) => {
    const missingParams = exports.getMissingRequiredInstanceParams(instance);
    return missingParams.length === 0;
};
exports.default = {
    getSessionFromInstance: exports.getSessionFromInstance,
    isInstanceInitialized: exports.isInstanceInitialized,
};
